import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { PresentationModeSettings } from "../presentation-mode.component";

@Component({
  selector: "astrobin-presentation-settings-dialog",
  templateUrl: "./presentation-settings-dialog.component.html",
  styleUrls: ["./presentation-settings-dialog.component.scss"]
})
export class PresentationSettingsDialogComponent implements OnInit {
  @Input() settings: PresentationModeSettings;
  @Output() save = new EventEmitter<PresentationModeSettings>();
  @Output() cancel = new EventEmitter<void>();

  settingsForm: FormGroup;

  readonly playbackSpeedOptions = [
    { value: 3, label: "3s" },
    { value: 5, label: "5s" },
    { value: 10, label: "10s" },
    { value: 15, label: "15s" },
    { value: 30, label: "30s" }
  ];

  readonly animationSpeedOptions = [
    { value: 300, label: "Fast" },
    { value: 500, label: "Normal" },
    { value: 1000, label: "Slow" }
  ];

  readonly animationTypeOptions = [
    { value: "none", label: "None" },
    { value: "fade", label: "Fade" },
    { value: "slide", label: "Slide" }
  ];

  readonly viewModeOptions = [
    { value: "static", label: "Static" },
    { value: "dynamic", label: "Dynamic (Ken Burns)" }
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.settingsForm = this.fb.group({
      playbackSpeed: [this.settings.playbackSpeed],
      animationSpeed: [this.settings.animationSpeed],
      animationType: [this.settings.animationType],
      viewMode: [this.settings.viewMode],
      autoHideControlsDelay: [this.settings.autoHideControlsDelay / 1000],
      blurredBackground: [this.settings.blurredBackground]
    });
  }

  onSave(): void {
    const formValue = this.settingsForm.value;
    const settings: PresentationModeSettings = {
      ...formValue,
      autoHideControlsDelay: formValue.autoHideControlsDelay * 1000
    };
    this.save.emit(settings);
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
